// extracted by mini-css-extract-plugin
export default {"container":"CarsDisplay_container__4Uldb"};